import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'
import { BlockStatus } from 'enum/block-status.enum'
import options from './options'
import { Wrapper } from './styled'

interface IProps {
  status: BlockStatus
}

const BlockBanner = ({ status }: IProps) => {
  const { t } = useTranslation()

  return (
    <Wrapper id="block-banner" status={status}>
      <FontAwesomeIcon icon={options[status].icon} />
      {options[status].prefix && <span>{`${t(options[status].prefix)} `}</span>}
      {t(options[status].title)}
    </Wrapper>
  )
}

export default BlockBanner
